import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '0',
      redirect: '/home'
    },
    {
      path: '/home',
      name: '0',
      component: resolve => require(['@/view/home'], resolve),
      meta: {
        title: '新希望乳业'
      }
    },
    {
      path: '/about-group',
      name: '1',
      component: resolve => require(['@/view/about/about-group'], resolve),
      meta: {
        title: '关于新希望 | 新希望集团'
      }
    },
    {
      path: '/about-dairy',
      name: '1',
      component: resolve => require(['@/view/about/about-dairy'], resolve),
      meta: {
        title: '关于新希望 | 新希望乳业'
      }
    },
    {
      path: '/about-layout',
      name: '1',
      component: resolve => require(['@/view/about/about-layout'], resolve),
      meta: {
        title: '关于新希望丨布局·历程'
      }
    },
    {
      path: '/about-honor',
      name: '1',
      component: resolve => require(['@/view/about/about-honor'], resolve),
      meta: {
        title: '关于新希望丨企业荣誉'
      }
    },
    {
      path: '/about-science',
      name: '1',
      component: resolve => require(['@/view/about/about-science'], resolve),
      meta: {
        title: '关于新希望丨科研成果'
      }
    },
    {
      path: '/about-culture',
      name: '1',
      component: resolve => require(['@/view/about/about-culture'], resolve),
      meta: {
        title: '关于新希望丨企业文化'
      }
    },
    {
      path: '/brand-choice',
      name: '2',
      component: resolve => require(['@/view/brand/brand-choice'], resolve),
      meta: {
        title: '品牌活动丨新鲜一代的选择'
      }
    },
    {
      path: '/brand-industryChain',
      name: '2',
      component: resolve => require(['@/view/brand/brand-industryChain'], resolve),
      meta: {
        title: '品牌活动丨优质乳产业链'
      }
    },
    {
      path: '/brand-forum',
      name: '2',
      component: resolve => require(['@/view/brand/brand-forum'], resolve),
      meta: {
        title: '品牌活动丨新鲜盛典'
      }
    },
    {
      path: '/brand-paradise',
      name: '2',
      component: resolve => require(['@/view/brand/brand-paradise'], resolve),
      meta: {
        title: '品牌活动丨食育乐园'
      }
    },
    {
      path: '/brand-fanFestival',
      name: '2',
      component: resolve => require(['@/view/brand/brand-fanFestival'], resolve),
      meta: {
        title: '品牌活动丨牛奶粉丝节'
      }
    },
    //{
    //  path: '/product',
    //  name: '3',
    //  component: resolve => require(['@/view/product/product'], resolve),
    //  meta: {
    //    title: '鲜活产品丨新版初心'
    //  }
    //},
    {
      path: '/product-home',
        name: '3',
      component: resolve => require(['@/view/product/product-home'], resolve),
      meta: {
        title: '鲜活产品丨鲜活产品'
      }
    },
    {
      path: '/product-star',
        name: '3',
      component: resolve => require(['@/view/product/product-star'], resolve),
      meta: {
        title: '鲜活产品丨明星产品'
      }
    },
    {
      path: '/product-single',
      name: '3',
      component: resolve => require(['@/view/product/product-single'], resolve),
      meta: {
        title: '鲜活产品丨特色单品'
      }
    },
    {
      path: '/productDetail',
      name: '3',
      component: resolve => require(['@/view/product/productDetail'], resolve),
      meta: {
        title: '鲜活产品丨详情'
      }
    },
    {
      path: '/news',
      name: '4',
      component: resolve => require(['@/view/news/news'], resolve),
      meta: {
        title: '新鲜资讯 | 新鲜FANS'
      }
    },
    {
      path: '/news1',
      name: '4',
      component: resolve => require(['@/view/news/news'], resolve),
      meta: {
        title: '新鲜资讯 | 媒体窗口'
      }
    },
    {
      path: '/news2',
      name: '4',
      component: resolve => require(['@/view/news/news'], resolve),
      meta: {
        title: '新鲜资讯 | Hi，新乳业'
      }
    },
    {
      path: '/newsDetail',
      name: '4',
      component: resolve => require(['@/view/news/newsDetail'], resolve),
      meta: {
        title: '新鲜资讯 | 咨询详情'
      }
    },
    {
      path: '/investor',
      name: '5',
      component: resolve => require(['@/view/investor/investor'],resolve),
      meta: {
        title: '投资者关系 | 股票动态'
      }
    },
    {
      path: '/investor0',
      name: '5',
      component: resolve => require(['@/view/investor/investor'],resolve),
      meta: {
        title: '投资者关系 | 最新公告'
      }
    },
    {
      path: '/investor1',
      name: '5',
      component: resolve => require(['@/view/investor/investor'],resolve),
      meta: {
        title: '投资者关系 | 定期报告'
      }
    },
    {
      path: '/investor2',
      name: '5',
      component: resolve => require(['@/view/investor/investor'],resolve),
      meta: {
        title: '投资者关系 | 公司治理'
      }
    },
    {
      path: '/develop-info',
      name: '6',
      component: resolve => require(['@/view/develop/develop-info'], resolve),
      meta: {
        title: '可持续发展丨可持续发展'
      }
    },
    {
      path: '/develop-withyou',
      name: '6',
      component: resolve => require(['@/view/develop/develop-withyou'], resolve),
      meta: {
        title: '可持续发展丨希望有你'
      }
    },
    {
      path: '/develop-respons',
      name: '6',
      component: resolve => require(['@/view/develop/develop-respons'], resolve),
      meta: {
        title: '可持续发展丨社会责任'
      }
    },
    {
      path: '/develop-green',
      name: '6',
      component: resolve => require(['@/view/develop/develop-green'], resolve),
      meta: {
        title: '可持续发展丨绿色环保'
      }
    },
    {
      path: '/technical-innovation',
      name: '7',
      component: resolve => require(['@/view/technical/technical-innovation'], resolve),
      meta: {
        title: '科技创新丨智慧牧场'
      }
    },
    {
      path: '/technical-digital',
      name: '7',
      component: resolve => require(['@/view/technical/technical-digital'], resolve),
      meta: {
        title: '科技创新丨数字工厂'
      }
    },
    {
      path: '/technical-research',
      name: '7',
      component: resolve => require(['@/view/technical/technical-research'], resolve),
      meta: {
        title: '科技创新丨科技研发'
      }
    },
    {
      path: '/technical-marketing',
      name: '7',
      component: resolve => require(['@/view/technical/technical-marketing'], resolve),
      meta: {
        title: '科技创新丨营销数字化'
      }
    },
    {
      path: '/ortherDetail',
      name: '9',
      component: resolve => require(['@/view/technical/ortherDetail'], resolve),
      meta: {
        title: '详情'
      }
    },
    {
      path: '/join-us',
      name: '8',
      component: resolve => require(['@/view/join/join-us'], resolve),
      meta: {
        title: '加入我们 | 招聘'
      }
    },
    {
      path: '/join-map',
      name: '8',
      component: resolve => require(['@/view/join/join-map'], resolve),
      meta: {
        title: '加入我们 | 联系我们'
      }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js